import { render, staticRenderFns } from "./OpportunitySidebarDetails.vue?vue&type=template&id=8ed17542&scoped=true&"
import script from "./OpportunitySidebarDetails.vue?vue&type=script&lang=js&"
export * from "./OpportunitySidebarDetails.vue?vue&type=script&lang=js&"
import style0 from "./OpportunitySidebarDetails.vue?vue&type=style&index=0&id=8ed17542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed17542",
  null
  
)

export default component.exports